import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAdminData, imageDeleted, imageAdded } from '../../redux/adminSlice';
import { useAuth0 } from '@auth0/auth0-react';
import AdminNavMain from './AdminNavComponent';
import AdminStats from './AdminStatsComponent';

function DisplayStats(props){

    const sendDataToModal = (event) => {
        props.toggle();

        props.setHiddenUrl(event.target.dataset.hiddenUrl);
        props.setClearUrl(event.target.dataset.clearUrl);
        props.setImageId(event.target.dataset.imageId);

        if (event.target.dataset.kidOrDog === 'kid') {
            props.isKid(true);
        } else {
            props.isKid(false);
        }
    }

    const deleteEntry = async (event) => {
        const deletePromiseResponse = await fetch( process.env.REACT_APP_DATABASE_URL + '/images', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                imageId: event.target.dataset.imageId
            })
        });
        const deleteResponse = await deletePromiseResponse.json();

        if (deleteResponse.success) {
            props.dispatch(imageDeleted(deleteResponse.image_id));
            alert("Image successfully deleted from database");
        } else if (deleteResponse.message) {
            alert(deleteResponse.message);
        } else {
            alert("Issue deleting image entry: " + deleteResponse.description)
        }
    };

    const updatePublishingStatus = async (event) => {

        const publishingPromise = await fetch(process.env.REACT_APP_DATABASE_URL + '/publish', {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`
            },
            body: JSON.stringify({
                image_id: event.target.dataset.imageId
            }),
            mode: 'cors'
        });

        const publishingResponse = await publishingPromise.json();

        if (publishingResponse.success) {
            event.target.checked = publishingResponse.publishing_status;
        } else {
            alert("Issue updating publishing status: " + publishingResponse.description);
        }
    };

    const [accessToken, setAccessToken] = useState('emptyTokenInDisplayStats');
    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {

        const getTokenAndImageData = async () => {
            const jwt = await getAccessTokenSilently();
            setAccessToken(jwt);
            props.dispatch(fetchAdminData(jwt));
        }

        getTokenAndImageData();

    }, [getAccessTokenSilently, props.dispatch, props]);

    const imagesStats = useSelector(state => state.adminStats.imagesStatsArray);

    const imagesStatsList = imagesStats.map((image) => {
        return(
            <div className="grid grid-cols-12 gap-2 items-start border-b border-gray-200 py-4" key={image.id}>
                {(image.id === parseInt(props.imageIdUpdated)) && (
                    <div className="col-span-12 mb-2">
                        <span className="inline-block px-2 py-1 bg-green-500 text-white text-xs font-semibold rounded">UPDATED</span>
                    </div>
                )}
                <div className="col-span-6 sm:col-span-3">
                    <img src={image.hiddenImage} className="w-full h-auto rounded" alt={image.id}/>
                </div>
                <div className="col-span-6 sm:col-span-3">
                    <img src={image.clearImage} className="w-full h-auto rounded" alt={image.id}/>
                </div>
                <div className="col-span-12 sm:col-span-4 text-sm text-gray-700">
                    <b>Image id:</b> {image.id}<br /><br />
                    <b>Image result:</b> {image.result}<br /><br />
                    <b>Total Number Views:</b> {image.total_numb_views}<br /><br />
                    <b>Total Right Answers:</b> {image.numb_right_answers}<br /><br />
                    <b>Success Rate:</b> { image.total_numb_views === 0 ? 'N/A' : ((image.numb_right_answers / image.total_numb_views) * 100).toFixed(2) + '%' }
                </div>
                <div className="col-span-12 sm:col-span-2 flex flex-col gap-2">
                    <label className="flex items-center gap-2 text-sm cursor-pointer">
                        <input
                            type="checkbox"
                            role="switch"
                            className="h-4 w-4"
                            data-image-id={image.id}
                            onChange={updatePublishingStatus}
                            checked={image.published}
                        />
                        Published
                    </label>
                    <button
                        className="px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition-colors"
                        onClick={sendDataToModal}
                        data-image-id={image.id}
                        data-hidden-url={image.hiddenImage}
                        data-clear-url={image.clearImage}
                        data-kid-or-dog={image.result}>
                            Update
                    </button>
                    <button
                        className="px-3 py-1 bg-red-600 text-white text-sm rounded hover:bg-red-700 transition-colors"
                        onClick={deleteEntry}
                        data-image-id={image.id}>
                            Delete
                    </button>
                </div>
            </div>
        )
    })

    return(
        <div className="max-w-7xl mx-auto px-4 py-3">
            {imagesStatsList}
        </div>
    )

}

function ModalOverlay({ isOpen, onClose, title, children }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={onClose}>
            <div className="bg-white rounded-lg shadow-xl w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between p-4 border-b border-gray-200">
                    <h3 className="text-lg font-semibold">{title}</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl leading-none">&times;</button>
                </div>
                <div className="p-4">
                    {children}
                </div>
            </div>
        </div>
    );
}

function ImageAdmin(){

    const dispatch = useDispatch();

    const [isModalOpen, setModal] = useState(false);
    const toggle = () => {
        setModal(!isModalOpen);
    }

    const [addingNewImage, setAddingNewImage] = useState(false);
    const newImageToggle = () => {
        setAddingNewImage(!addingNewImage);
    };

    const [urlHidden, setUrlHidden] = useState('');
    const [urlClear, setUrlClear] = useState('');
    const [isKid, setIsKid] = useState('');
    const [imageId, setImageId] = useState('');

    const [imageIdUpdated, setImageIdUpdated] = useState('');
    const [updateBool, setUpdateBool] = useState(false);

    if(updateBool){
        setUpdateBool(false);
    }

    const [accessToken, setAccessToken] = useState('emptyTokenInAdmin');
    const { getAccessTokenSilently } = useAuth0();

    useEffect(() => {

        const getToken = async () => {
            const jwt = await getAccessTokenSilently();
            setAccessToken(jwt);
        }

        getToken();

    }, [getAccessTokenSilently]);

    const submitImageForm = async (event) => {

        event.preventDefault();

        const imageResult = event.target.kidordog.value

        const hiddenImage = event.target.imageHidden.files[0];
        const clearImage = event.target.imageClear.files[0];

        const formData = new FormData();

        formData.append('hidden_image', hiddenImage);
        formData.append('clear_image', clearImage);
        formData.append('result', imageResult);

        let postImagePromise = ''
        try {
            postImagePromise = await fetch(process.env.REACT_APP_DATABASE_URL + '/images', {
                method: 'POST',
                mode: 'cors',
                body: formData,
                headers:{
                    'Authorization': `Bearer ${accessToken}`,
                }
            });
        } catch (err) {
            alert('Issue while attempting to add image to database');
            return;
        }

        const postImageReturn = await postImagePromise.json();

        if(postImageReturn.success){
            dispatch(imageAdded(postImageReturn.image_uploaded));
            alert('Image was successfully added to database!');
        } else {
            alert('Issue adding new image entry to database: ' + postImageReturn.description);
        }

        setAddingNewImage(false);
    }

    const updateDataEntry = async (event) => {

        event.preventDefault();

        const updatedImageResult = event.target.kidordog.value
        const updatedHiddenImage = event.target.imageHidden.files[0];
        const updatedClearImage = event.target.imageClear.files[0];

        const updateFormData = new FormData();

        updateFormData.append('image_id', imageId);
        updateFormData.append('updated_hidden_image', updatedHiddenImage);
        updateFormData.append('updated_clear_image', updatedClearImage);
        updateFormData.append('updated_result', updatedImageResult);

        const promiseUpdateImage = await fetch(process.env.REACT_APP_DATABASE_URL + '/images', {
            method: 'PATCH',
            mode: 'cors',
            body: updateFormData,
            headers:{
                'Authorization': `Bearer ${accessToken}`
            }
        });

        const response = await promiseUpdateImage.json();

        if(response.success){
            setImageIdUpdated(response.image_id);
            alert('Image has been updated successfully');
        } else {
            alert('Issue updating image entry: ' + response.description);
        }

        setModal(false);
    }

    const sendDataToNewImageModal = () => {
        newImageToggle();
    }

    return(
        <>
            <ModalOverlay isOpen={isModalOpen} onClose={toggle} title="Updating Database Entry">
                <form onSubmit={updateDataEntry}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Image Hidden</label>
                        <img src={urlHidden} className="w-full h-auto rounded mb-2" alt={urlHidden}/>
                        <input type="file" name="imageHidden" className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" onChange={(e) => {
                            setUrlHidden(e.target.files[0].name);
                        }} />
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Image Clear</label>
                        <img src={urlClear} className="w-full h-auto rounded mb-2" alt="" />
                        <input type="file" name="imageClear" className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" onChange={(e) => {e.preventDefault()}} />
                    </div>
                    <div className="mb-4">
                        <p className="text-sm font-medium text-gray-700 mb-2">Kid or Dog?</p>
                        <div className="flex gap-4">
                            <label className="flex items-center gap-1 text-sm">
                                <input type="radio" name="kidordog" value="kid" checked={isKid} onChange={() => setIsKid(!isKid)}/>
                                Kid
                            </label>
                            <label className="flex items-center gap-1 text-sm">
                                <input type="radio" name="kidordog" value="dog" checked={!isKid} onChange={() => setIsKid(!isKid)}/>
                                Dog
                            </label>
                        </div>
                    </div>
                    <hr className="my-4" />
                    <div className="flex justify-center gap-3">
                        <button className="px-4 py-2 bg-gray-500 text-white text-sm rounded hover:bg-gray-600 transition-colors" type="button" onClick={toggle}>Cancel</button>
                        <button className="px-4 py-2 bg-amber-500 text-white text-sm rounded hover:bg-amber-600 transition-colors" type="submit">Update Data</button>
                    </div>
                </form>
            </ModalOverlay>

            <ModalOverlay isOpen={addingNewImage} onClose={newImageToggle} title="Add New Image">
                <form onSubmit={submitImageForm}>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Image Hidden</label>
                        <input type="file" name="imageHidden" className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" onChange={(e) => {e.preventDefault()}}/>
                    </div>
                    <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Image Clear</label>
                        <input type="file" name="imageClear" className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" onChange={(e) => {e.preventDefault()}}/>
                    </div>
                    <div className="flex items-center justify-center gap-4 mb-4">
                        <label className="flex items-center gap-1 text-sm">
                            <input type="radio" name="kidordog" value="kid"/>
                            Kid
                        </label>
                        <label className="flex items-center gap-1 text-sm">
                            <input type="radio" name="kidordog" value="dog"/>
                            Dog
                        </label>
                    </div>
                    <div className="flex justify-center">
                        <button type="submit" className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded hover:bg-blue-700 transition-colors">Add New Image</button>
                    </div>
                </form>
            </ModalOverlay>

            <AdminNavMain extraNavItems={
                <button
                    className="px-3 py-1.5 bg-blue-600 text-white text-sm rounded hover:bg-blue-700 transition-colors"
                    onClick={sendDataToNewImageModal}>
                    Add New Image
                </button>
            } />
            <div className="max-w-7xl mx-auto px-4 pt-16">
                <h1 className="text-2xl font-bold text-gray-800 my-4">Image Admin</h1>
            </div>
            <AdminStats />
            <DisplayStats
                dispatch={dispatch}
                toggle={toggle}
                setHiddenUrl={setUrlHidden}
                setClearUrl={setUrlClear}
                setImageId={setImageId}
                isKid={setIsKid}
                imageIdUpdated={imageIdUpdated}
            />
        </>
    )
}

export default ImageAdmin;
